import { fetchJson } from '@atlassian/jira-fetch/src/index.tsx';
import {
	createResource,
	useResource,
	type ResourceStoreContext,
	type RouterContext,
	type RouterDataContext,
} from '@atlassian/react-resource-router';
import { getIssueKey } from '@atlassian/jira-router-resources-utils/src/utils/get-issue-key/index.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const jsmIssueViewSlaPanelResource = createResource({
	type: 'JSM_ISSUE_VIEW_SLA_PANEL_RESOURCE',
	getKey: ({ match }: RouterContext) => {
		const issueKey = getIssueKey(match);

		return issueKey || '';
	},
	getData: async ({ match }: RouterDataContext, { tenantContext }: ResourceStoreContext) => {
		// ServiceDesk access check is only enforced when jsm-issue-view-sla-panel-high-load-protection fg is enabled,
		// allowing us to restrict access during high load scenarios
		if (
			!tenantContext.appEditions.serviceDesk &&
			fg('jsm-issue-view-sla-panel-high-load-protection')
		) {
			return null;
		}

		const issueKey = getIssueKey(match);

		if (!issueKey) {
			return null;
		}

		try {
			const url = `/rest/servicedesk/1/servicedesk/sla/issue/${issueKey}`;

			const response = await fetchJson(url, { method: 'GET' });
			if (!response.errors) {
				return response;
			}
		} catch (error: unknown) {
			fireErrorAnalytics({
				error: error instanceof Error ? error : new Error(String(error)),
				sendToPrivacyUnsafeSplunk: true,
				meta: {
					id: 'jsmIssueViewSlaPanelResource',
					packageName: 'jiraRouterResourcesJsmIssueView',
					teamName: 'jsd-shield',
				},
			});
		}

		return null;
	},
});

export const getJsmIssueViewSlaPanelResource = () => jsmIssueViewSlaPanelResource;

export const useJsmIssueViewSlaPanelResource = () => {
	return useResource(jsmIssueViewSlaPanelResource);
};
